<template>
  <section class="content">
    <div class="loading-overlay" v-if="loading">
      <div class="spinner"></div>
      <h4>Loading Data...</h4>
    </div>
    <div class="box box-info">
    <div class="p-toolbar p-component mb-4">
      <button class="p-button p-component p-button-help exportBtn" type="button" @click.prevent="exportCSV()" v-if="this.customerLists.length > 0">
        <span class="pi pi-upload p-button-icon p-button-icon-left"></span><span class="p-button-label">Export</span>
        <span class="p-ink"></span>
      </button>
      <customeraccountdialog ref="openDialog"/>
    </div>
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
          <DataTable ref="po"
                     :value="customerLists"
                     :paginator="true" :rows="100"   :rowsPerPageOptions="[100,500,1000]"
                     :filters="filters"
                     class="p-datatable-responsive p-datatable-gridlines"
                     :selection.sync="selectedProduct1" selectionMode="single"
          >
            <Column header="S.n">
              <template #body="slotProps">
                {{ slotProps.index + 1 }}
              </template>
            </Column>
            <Column :sortable="true"   header="Name" field="name" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['name']"/>
              </template>
            </Column>
            <Column :sortable="true"
                    header="Short Name"
                    field="shortName"
                    filterMatchMode="contains"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['shortName']"/>
              </template>
            </Column>

            <Column :sortable="true" header="Contact name" field="contactName" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['contactName']"/>
              </template>
            </Column>

            <Column :sortable="true" header="Contact Number" field="primaryContactNumber" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['primaryContactNumber']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Address" field="address" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['address']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Pan No" field="panNo" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['panNo']"/>
              </template>
            </Column>
             <Column :sortable="true" header="Customer Type" field="customerType" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['customerType']"/>
              </template>
            </Column>

            <Column :sortable="true"
                    header="Opn Balance"
                    field="openingBalance"
                    filterMatchMode="contains"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['openingBalance']"/>
              </template>
            </Column>

            <Column :sortable="true"
                    header="Dr-Cr"
                    field="openingDrCr"
                    filterMatchMode="contains"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['openingDrCr']"/>
              </template>
            </Column>
            <Column :sortable="true"
                    header="Status"
                    field="status"
                    filterMatchMode="contains"
            >
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['status']"/>
              </template>
            </Column>
            <Column header="Action" headerStyle="width: 11em">
              <template #body="slotProps">


                <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                        @click="editCustomer(slotProps.data)"/>

                <Button icon="pi pi-trash" class="p-button-danger p-button-sm"
                        @click="openDialog(slotProps.data.id)"/>
                <Button icon="pi pi-check" class="p-button-raised p-button-success"
                        @click="verifyCustomer(slotProps.data.id)"/>
              </template>
            </Column>


          </DataTable>
          </div>
          </div>
        </div>
      <!-- </div>
    </div> -->
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteAccountMaster"/>

  </section>

</template>
<script>
import customeraccountdialog from '../accountDialog/CustomerAccountDialog.vue'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'

export default {
  name: 'customer',
  data() {
    return {
      displayBasic: false,
      dialogShow: false,
      selectedProduct1: null,
      loading: true,
      columnList: '',
      filters: {}
    }
  },
  computed: {
    customerLists() {
      return this.$store.state.accountMaster.customerLists
    }
  },
  mounted() {
    this.customerList()
    this.columnNames()
  },
  methods: {
    async deleteAccountMaster(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        accountMasterId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteAccMaster', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.closeDialog()
        this.dialogShow = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.dialogShow = false
        this.closeDialog()
      }
    },
    async verifyCustomer(value) {
      let deleteRe = {
        accountMasterId: value,
        verify: true
      }
      let resp = await this.$store.dispatch('verifyCustomer', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    editCustomer(data) {
      this.$refs.openDialog.editCustomer(data)
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Customer List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'customerList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    async customerList() {
      this.loading = true
      try {
        let res = await this.$store.dispatch('loadCustomerAccountList')
        console.log(res.data.data)
        return res
      } finally {
        this.loading = false
      }
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    },
    cancel(data) {
      this.dialogShow = false
    }
  },
  components: {
    Column,
    DataTable,
    Dialog,
    InputText,
    customeraccountdialog,
    Button
  }
}
</script>
<style scoped>
/* Loading Overlay Styles */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-overlay h4 {
  font-size: 1.5rem;
  color: #2c3e50;
}
</style>




// WEBPACK FOOTER //
// CustomerAccount.vue?7d39a334